<app-submission-menu-item
#menuItems
class="menu-items"
*ngFor="let item of academySvc.keyBoardMenu.keyboardMenuItems"
[keyboardMenuItem]="item"></app-submission-menu-item>
